import React from 'react';
import './SuccessModal.css';

const SuccessModal = ({ isOpen, onClose, problemTitle }) => {
  if (!isOpen) return null;

  return (
    <div className="success-modal-overlay" onClick={onClose}>
      <div className="success-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="success-modal-content__glass">
          <div className="success-modal-body">
            <div className="success-icon-container">
              <span className="success-icon" aria-hidden>
                ✓
              </span>
            </div>
            <h2 className="success-title">COMPLETED</h2>

            <div className="success-actions">
              <button type="button" className="sign-in-btn" onClick={onClose}>
                Continue Learning
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;
